import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "react-bootstrap";
import TableTemplate from "../../../../../Components/Table/TableTemplate";
import { RETURNS_ALL } from "../../../../../Constants/Endpoints";
import "./LinkToReturnModal.scss";
import {
  logisticsLinkToReturnParams,
  logisticsUnlinkToBarcodeParams,
} from "../../../../../Backend/LogisticsRequests";
import { displayDateTime } from "../../../../../Helpers/utils/utils";

export function LinkToReturnModal({
  logisticsPackage,
  line,
  submit,
  ...props
}) {
  const [t] = useTranslation();
  const tableSchoolsRef = useRef(null);

  const [highlightKey] = useState("id");
  const [returnSelected, setReturnSelected] = useState();
  const [highlightReturnValues, setHighlightReturnValues] = useState([]);

  //#region Handlers
  function handleSelectReturn(returnal) {
    setReturnSelected(returnal);
    setHighlightReturnValues([returnal.id]);
  }

  async function handleConfirmButton() {
    const result = await putLogisticsLinkToReturn();

    if (result) {
      submit();
    }
  }

  async function handleUnlinkButton() {
    const result = await putLogisticsUnlinkToReturn();

    if (result) {
      submit();
    }
  }

  //#endregion

  //#region Functions
  async function putLogisticsLinkToReturn() {
    const resp = await logisticsLinkToReturnParams(
      logisticsPackage.id,
      returnSelected.id
    );

    return resp.success;
  }

  async function putLogisticsUnlinkToReturn() {
    const resp = await logisticsUnlinkToBarcodeParams(logisticsPackage.id);

    return resp.success;
  }

  //#endregion

  const returnalsColumns = [
    {
      name: "customerUid",
      headerCaption: t("CustomerUid"),
      size: "normal",
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "schoolUid",
      headerCaption: t("SchoolNumber"),
      size: "normal",
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "uid",
      headerCaption: t("ReturnNumber"),
      size: "normal",
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "createdAt",
      headerCaption: t("CreatedAt"),
      size: "normal",
      canSort: true,
      canFilter: true,
      canEdit: false,
      caption: (x) => displayDateTime(x.createdAt),
    },
    {
      name: "actions",
      headerCaption: "",
      size: "small",
      textAlign: "center",
      canSort: false,
      canFilter: false,
      canEdit: false,
      caption: (x) => {
        return (
          <Button
            className="button-selected"
            disabled={highlightReturnValues[0] === x.id}
            onClick={() => handleSelectReturn(x)}
          >
            {highlightReturnValues[0] === x.id ? t("Selected") : t("Select")}
          </Button>
        );
      },
    },
  ];

  return (
    <Modal {...props} centered dialogClassName="link-to-barcode-modal">
      <Modal.Header className="link-to-barcode-modal-header" closeButton>
        <h2 className="title">{t("Line")}</h2>
      </Modal.Header>
      <Modal.Body className="link-to-barcode-modal-content">
        <TableTemplate
          ref={tableSchoolsRef}
          pageSize={8}
          highlightValues={highlightReturnValues}
          highlightKey={highlightKey}
          endpoint={RETURNS_ALL}
          columns={returnalsColumns}
          uniqueId="returnUid"
          paginator={true}
          showSizeSelector={false}
        />
        <div className="button-wrapper">
          {logisticsPackage.barcodeReturn && (
            <Button className="button-unlink" onClick={handleUnlinkButton}>
              {t("Unlink")}
            </Button>
          )}
          <Button
            className="button"
            disabled={highlightReturnValues.length === 0}
            onClick={handleConfirmButton}
          >
            {t("Confirm")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
